import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { DataService } from '../services/data.service';
import { API_ENDPOINT$ } from '../shared/index';
import { HttpHeaders, HttpParams } from '@angular/common/http';
@Injectable({
  providedIn: 'root'
})
export class UserManagementService {
  private getSitesWithUsersUrl = `${API_ENDPOINT$}/site/getSitesWithUsers`;
  private getMaxSiteUserPerSiteUrl = `${API_ENDPOINT$}/manageproject/getMaxSiteUserPerSite`;
 
  private saveOrUpdateUserUrl = `${API_ENDPOINT$}/user/saveOrUpdateUser`;
  // Role and Feature Management
  private roleWithActivitiesUrl = `${API_ENDPOINT$}/role/roleWithActivities`;
  private getRoleTreeUrl = `${API_ENDPOINT$}/common/getRoleTree`;
  private createNewRoleUrl = `${API_ENDPOINT$}/manageproject/createNewRole`;
  private updateRoleUrl = `${API_ENDPOINT$}/manageproject/updateRole`;
  private deleteRoleUrl = `${API_ENDPOINT$}/manageproject/deleteRole`;
  // Activities
  private getAllActivitiesUrl = `${API_ENDPOINT$}/common/getAllActivities`;
  private getActivitiesOfRoleUrl = `${API_ENDPOINT$}/common/getActivitiesOfRole`;
  private getActivitiesOfUserUrl = `${API_ENDPOINT$}/common/getActivitiesOfUser`;
  private getUserListBySiteUrl = `${API_ENDPOINT$}/common/getUserListBySite`;
  private getDeleteUserUrl = `${API_ENDPOINT$}/manageproject/deleteUser`;
  private getValidateNTIDUrl = `${API_ENDPOINT$}/user/validateNTID`;
  private getUserListByRoleUrl = `${API_ENDPOINT$}/common/getUserListByRole`;
  private getAddUserUrl = `${API_ENDPOINT$}/manageproject/createNewUser`;
  private getUpdateUserUrl = `${API_ENDPOINT$}/manageproject/updateUser`;
  private getRolesUrl = `${API_ENDPOINT$}/role`;
  private getroleWithActivitiesUrl = `${API_ENDPOINT$}/common/getRoleWithActivities`;
  private getSelectableRolesUrl = `${API_ENDPOINT$}/common/getSelectableRoles`;

  
  constructor(private dataService: DataService) { }
  public getSitesWithUsers(): Observable<any> {
    return this.dataService.getData(this.getSitesWithUsersUrl);
  }
  public getMaxSiteUserPerSite(): Observable<any> {
    return this.dataService.getData(this.getMaxSiteUserPerSiteUrl);
  }
  public getRoles(): Observable<any> {
    return this.dataService.getData(this.getRolesUrl);
  }
  public saveOrUpdateUser(user: any): Observable<any> {
    return this.dataService.postData(this.saveOrUpdateUserUrl, user);
  }
  public getAllActivities = (): Observable<any> => {
    return this.dataService.getData(this.getAllActivitiesUrl);
  }
  public getActivitiesOfRole = (roleRId: any): Observable<any> => {
    const params = new HttpParams().set('roleRId', roleRId);
    const url = `${this.getActivitiesOfRoleUrl}/${params}`;
    const urlEncodeURI = url.replace('roleRId=', '');
    return this.dataService.getData(urlEncodeURI);
  }
  public getActivitiesOfUser = (userName: string) : Observable<any> => {
    return this.dataService.getData(this.getActivitiesOfUserUrl + '/' + userName);
  }
  public getRoleWithActivities = (): Observable<any> => {
    return this.dataService.getData(this.roleWithActivitiesUrl);
  }
  public getRoleTree = (): Observable<any> => {
    return this.dataService.getData(this.getRoleTreeUrl);
  }
  public createNewRole = (model: any): Observable<any> => {
    return this.dataService.postData(this.createNewRoleUrl, model);
  }
  public updateRole = (model: any): Observable<any> => {
    return this.dataService.postData(this.updateRoleUrl, model);
  }
  public deleteRole = (model: any): Observable<any> => {
    return this.dataService.postData(this.deleteRoleUrl, model);
  }
  public getUserListBySite = (siteId: string): Observable<any> => {
    return this.dataService.getData(`${this.getUserListBySiteUrl}/${siteId}`);
  }
  public deleteUser = (username: string): Observable<any> => {
    return this.dataService.postData(this.getDeleteUserUrl, username);
  }
  public ValidateNTID(user: any): Observable<any> {
    return this.dataService.postData(this.getValidateNTIDUrl, user);
  }
  public getUserListByRole = (roleRId: string): Observable<any> => {
    return this.dataService.getData(`${this.getUserListByRoleUrl}/${roleRId}`);
  }
  public getroleWithActivities = (): Observable<any> => {
    return this.dataService.getData(`${this.getroleWithActivitiesUrl}`);
  }
  public getFeatureOfRole = (roleRId: string): Observable<any> => {
    return this.dataService.getData(`${this.getActivitiesOfRoleUrl}/${roleRId}`);
  }
  public addUser(user: any): Observable<any> {
    return this.dataService.postData(this.getAddUserUrl, user);
  }
  public updateUser(user: any): Observable<any> {
    return this.dataService.postData(this.getUpdateUserUrl, user);
  }
  public getSelectableRoles = (): Observable<any> => {
    return this.dataService.getData(`${this.getSelectableRolesUrl}`);
  }
}
